import { Switch } from "antd";
import "antd/dist/reset.css"; // Ensure Ant Design styles are imported
import React, { useEffect, useState } from "react";

const ThemeToggle = () => {
  const [theme, setTheme] = useState(
    () => localStorage.getItem("theme") || "dark"
  );

  useEffect(() => {
    document.body.classList.toggle("light", theme === "light");
    document.body.classList.toggle("dark", theme === "dark");
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = (checked) => {
    setTheme(checked ? "dark" : "light");
  };

  return (
    <div className="mode_toggle">
      <p>{theme === "dark" ? "Dark Mode" : "Light Mode"}</p>
      <Switch
        checked={theme === "dark"}
        onChange={toggleTheme}
        className="custom-switch"
      />
    </div>
  );
};

export default ThemeToggle;
